import { Browser } from '@capacitor/browser'
import { Capacitor } from '@capacitor/core'
import { ReactNode } from 'react'
import { APP_URL } from '~/shared/config/env'
import { Button } from '~/shared/ui/Buttons'
import { DrawerComponent } from '~/shared/ui/Drawer'
import {
  Title,
  Description,
  Img,
  LoginWrapper,
  Wrapper,
  TitleWrapper,
  ButtonWrapper,
} from './styled'

type UnAuthProposalRegistrationDrawerProps = {
  isShow: boolean
  onCancel: () => void
  taxiparkId?: UniqueId
  descriptions: ReactNode
  registrationType?: 'full' | 'simplified'
}

export function UnAuthProposalRegistrationDrawer({
  isShow,
  onCancel,
  taxiparkId,
  descriptions,
  registrationType = 'full',
}: UnAuthProposalRegistrationDrawerProps) {
  const registrationPath =
    registrationType === 'simplified'
      ? `/simplified-registration`
      : `/registration`

  const platform = Capacitor.getPlatform()
  const isSimplifiedOnNative =
    platform !== 'web' && registrationType === 'simplified'

  const handleRegistrationClick = async () => {
    if (isSimplifiedOnNative) {
      await Browser.open({
        url: `${APP_URL}/simplified-registration?taxiparkId=${taxiparkId}&from=${platform}`,
      })
    }
  }

  return (
    <DrawerComponent
      isShow={isShow}
      onCancel={onCancel}
      contentProps={{
        className: 'ion-content-scroll-host',
        style: {
          height: '90vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        },
      }}
    >
      <Wrapper>
        <TitleWrapper>
          <Title data-testid='booking-car-register-drawer-title'>
            Присоединяйся к команде
          </Title>
          <Description data-testid='booking-car-register-drawer-description'>
            {descriptions}
          </Description>
        </TitleWrapper>

        <Img src='/images/bookingCarRegister.png' alt='' />

        <ButtonWrapper>
          <Button
            size='large'
            fullWidth
            variant='limeFlooded'
            {...(isSimplifiedOnNative
              ? { onClick: handleRegistrationClick }
              : { to: `${registrationPath}/?taxiparkId=${taxiparkId}` })}
            style={{ marginBottom: '12px' }}
          >
            Регистрация
          </Button>

          <LoginWrapper>
            Уже есть аккаунт?
            <Button
              size='large'
              variant='textLink'
              to='/login'
              contentProps={{
                style: { padding: '0', marginLeft: '4px', minWidth: '50px' },
              }}
            >
              Вход
            </Button>
          </LoginWrapper>
        </ButtonWrapper>
      </Wrapper>
    </DrawerComponent>
  )
}
